import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';


const Plan13 = withTableController(({ planing, state }) => (
  <Plan
    planing={planing}
    state={state}
  />
));

export default Plan13;
